import { Check } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";

const FACTS = [
  "Direct sourcing from Indonesian vanilla-growing regions, with batch-level origin traceability.",
  "Specifications — moisture, vanillin, length — shared transparently per batch before you commit.",
  "Samples available on request so you can verify quality before a commercial order.",
  "Export documentation support, including Phytosanitary Certificates where applicable.",
  "Responsive communication on WhatsApp and email throughout inquiry, packing, and dispatch.",
  "No inflated claims: what we quote is what ships.",
];

export const Trust = () => (
  <section id="trust" data-testid="trust-section" className="py-20 sm:py-28 px-4 sm:px-8">
    <div className="max-w-5xl mx-auto">
      <SectionHeader
        eyebrow="05 · Built for International B2B Trade"
        title="Facts, Not Badges"
        sub="We don't decorate this page with borrowed logos or invented numbers. Here is exactly how we work with buyers abroad."
      />
      <div className="grid sm:grid-cols-2 gap-x-10 gap-y-5">
        {FACTS.map((f, i) => (
          <Reveal key={f} delay={i * 0.05}>
            <div data-testid={`trust-fact-${i}`} className="flex items-start gap-3.5">
              <span className="mt-0.5 w-6 h-6 rounded-full bg-[#EAF0EC] text-[#2E4F3E] flex items-center justify-center shrink-0">
                <Check size={14} strokeWidth={3} />
              </span>
              <p className="text-sm sm:text-base text-[#2C1A0C]/85 leading-relaxed">{f}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
